import { BaseQuantity } from "../../interface/functionalityInterface";

// Derived base quantity
// coherent SI unit is normal cubic metres per second
export const NormalFlow: BaseQuantity = {
  id: "001normalFlow",
  name: "normal_flow",
  type: "numeric",
  value: "",
  symbol: "Qₙ",
  baseUnit: "Nm³/s",
  selectedUnit: "Nm³/h",
  units: [
    { name: "Nm³/s", fromConst: 1, toConst: 1 },
    { name: "Nm³/h", fromConst: 1 / 3600, toConst: 3600 },
    { name: "Nl/s", fromConst: 1 / 1000, toConst: 1000 },
    {
      name: "Nl/min",
      fromConst: 1 / (1000 * 60),
      toConst: 1000 * 60,
    },
  ],
};
